import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import {NgbActiveModal, NgbModal, NgbModalOptions} from "@ng-bootstrap/ng-bootstrap";
import { AccountProvider } from 'src/providers/account/account';
import { CadastroPlanoDeContasComponent } from '../cadastro-plano-de-contas/cadastro-plano-de-contas.component';
import { ReplaySubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-pre-cadastro-do-plano-de-contas',
  templateUrl: './pre-cadastro-do-plano-de-contas.component.html',
  styleUrls: ['./pre-cadastro-do-plano-de-contas.component.scss']
})
export class PreCadastroDoPlanoDeContasComponent implements OnInit {
  public conta_movimento: FormControl = new FormControl();
  public contas
  public accountMultiFilterCtrl: FormControl = new FormControl();
  public filteredAccountsMulti: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  protected _onDestroy = new Subject<void>();

  constructor(public activeModal: NgbActiveModal,
    private accountProvider: AccountProvider,
    public modalService: NgbModal
  ) { }

  protected filterAccountMulti() {
    if (!this.contas) {
      return;
    }
    let search = this.accountMultiFilterCtrl.value;
    if (!search) {
      this.filteredAccountsMulti.next(this.contas.slice());
    } else {
      search = search.toLowerCase();
      this.filteredAccountsMulti.next(
        this.contas.filter(value => value.description.toLowerCase().indexOf(search) > -1)
          .sort((a, b) => a.description.indexOf(search) - b.description.indexOf(search))
      );
    }
  }



  ngOnInit() {
      this.accountProvider.getAllComposeAccounts().then((result) => {
      this.contas = result
      this.filterAccountMulti();
    });
    this.accountMultiFilterCtrl.valueChanges.pipe(takeUntil(this._onDestroy)).subscribe(() => {
          this.filterAccountMulti();
        });
  }
  openCadastroModal(node: any, customId, description){
    let modalOptions: NgbModalOptions = {
      backdrop: 'static',
      windowClass: localStorage.getItem('theme') == 'dark'? 'dark-theme' : ''
    };
    const modalRef = this.modalService.open(CadastroPlanoDeContasComponent, modalOptions);
    // console.log("previous node", node)
    modalRef.componentInstance.node =(node.description == 'root' && node.customId==null) ? node.id:node;
    modalRef.componentInstance.editar = false;
    modalRef.componentInstance.root = (node.description == 'root' && node.customId==null) ? true : false;
    modalRef.componentInstance.customIds = [customId];
    modalRef.componentInstance.descriptions = [description];
    modalRef.componentInstance.goBack = true
    modalRef.result.then((result: any) => {
      if(result != 'back'){
      this.activeModal.close(result);
      }
     // console.log("t1 ", result)
    }, () => {
    });
  }
}
